import styled from 'styled-components';

export const TeamManagementTabStyle = styled.div`
  width: 100%;
  padding: 0;

  h3 {
    font-size: 16px;
    color: ${props => props.theme.colors.primary};
    font-weight: 600;
    margin-bottom: 6px;
  }

  .sectionDescription {
    color: #888;
    font-size: 13px;
    margin-bottom: 16px;
  }

  /* Upgrade Prompt for Free Users */
  .upgradePrompt {
    background: #111823;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 36px;
    text-align: center;
    margin-bottom: 24px;

    h2 {
      font-size: 18px;
      color: ${props => props.theme.colors.primary};
      margin: 14px 0;
    }

    p {
      color: #888;
      font-size: 13px;
      margin-bottom: 20px;
    }

    .addSong {
      display: flex;
      align-items: center;
      justify-content: center;
      background: #007afe;
      padding: 0px 24px;
      height: 40px;
      font-family: 'Poppins', sans-serif;
      font-size: 13px;
      font-weight: 600;
      line-height: 1;
      letter-spacing: -0.01em;
      text-align: center;
      border-radius: 8px;
      border: none;
      color: #fff;
      margin-right: 8px;
      cursor: pointer;
      transition: all 0.2s ease;
      box-shadow: 0 2px 8px rgba(0, 122, 254, 0.2);

      &:hover {
        background: #0056cc;
        box-shadow: 0 4px 12px rgba(0, 122, 254, 0.3);
      }

      &:active {
        box-shadow: 0 2px 6px rgba(0, 122, 254, 0.2);
      }
    }

    .ant-btn-primary {
      background: #007afe;
      border-color: #007afe;
      height: 40px;
      padding: 0 28px;
      font-size: 13px;
    }
  }

  /* Invite Section */
  .inviteSection {
    background: #111823;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 24px;

    .inviteForm {
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin-top: 16px;

      .ant-btn-primary:disabled {
        width: 100%;
      }

      .ant-input {
        background: #181e27;
        border: 1px solid rgba(255, 255, 255, 0.08);
        color: ${props => props.theme.colors.primary};

        &::placeholder {
          color: #666;
        }

        &:hover,
        &:focus {
          border-color: #007aff;
          box-shadow: none;
        }
      }

      .profileSelection {
        .selectionLabel {
          color: ${props => props.theme.colors.primary};
          font-size: 13px;
          margin-bottom: 10px;
          font-weight: 500;
        }

        .customCheckboxGroup {
          display: flex;
          flex-direction: column;
          gap: 10px;

          .customCheckbox {
            display: flex;
            align-items: center;
            padding: 10px;
            background: #181e27;
            border: 1px solid rgba(255, 255, 255, 0.08);
            border-radius: 8px;
            cursor: pointer;
            transition: all 0.2s ease;
            position: relative;

            &:hover {
              border-color: rgba(0, 122, 255, 0.3);
              background: rgba(0, 122, 255, 0.04);
            }

            &.checked {
              border-color: rgba(0, 122, 255, 0.4);
              background: rgba(0, 122, 255, 0.06);
            }

            input[type='checkbox'] {
              position: absolute;
              opacity: 0;
              cursor: pointer;
              height: 0;
              width: 0;
            }

            .checkmark {
              position: relative;
              height: 18px;
              width: 18px;
              background-color: #181e27;
              border: 1px solid rgba(255, 255, 255, 0.2);
              border-radius: 4px;
              margin-right: 10px;
              flex-shrink: 0;
              transition: all 0.2s ease;

              &::after {
                content: '';
                position: absolute;
                display: none;
                left: 5px;
                top: 2px;
                width: 5px;
                height: 9px;
                border: solid white;
                border-width: 0 2px 2px 0;
                transform: rotate(45deg);
              }
            }

            input:checked ~ .checkmark {
              background-color: #007aff;
              border-color: #007aff;
            }

            input:checked ~ .checkmark::after {
              display: block;
            }

            .profileName {
              color: ${props => props.theme.colors.primary};
              font-size: 13px;
            }

            .ant-avatar {
              flex-shrink: 0;
            }
          }
        }
      }

      .ant-btn-primary {
        background: #007aff;
        border-color: #007aff;
        height: 38px;
        font-size: 13px;
        border-radius: 8px;

        &:hover {
          background: #0056cc;
          border-color: #0056cc;
        }

        &:disabled {
          background: #252d3a;
          border-color: #252d3a;
          color: #666;
        }
      }
    }
  }

  /* Pending Invitations Section */
  .pendingInvitationsSection {
    background: #111823;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 24px;

    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 32px;
      color: ${props => props.theme.colors.primary};
    }

    .invitationCards {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
      gap: 12px;
      margin-top: 16px;

      .invitationCard {
        background: #181e27;
        border: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 10px;
        padding: 16px;
        transition: all 0.2s ease;

        &:hover {
          border-color: rgba(0, 122, 254, 0.3);
        }

        .cardHeader {
          margin-bottom: 14px;

          h4 {
            font-size: 15px;
            color: ${props => props.theme.colors.primary};
            margin-bottom: 4px;
            font-weight: 600;
          }

          .email {
            font-size: 12px;
            color: #888;
          }
        }

        .cardBody {
          margin-bottom: 14px;

          .profileCount {
            font-size: 12px;
            color: #007afe;
            margin-bottom: 10px;
            font-weight: 500;
          }

          .profiles {
            display: flex;
            flex-direction: column;
            gap: 6px;
            margin-bottom: 10px;

            .profileItem {
              display: flex;
              align-items: center;
              gap: 8px;
              font-size: 12px;
              color: ${props => props.theme.colors.primary};
            }
          }

          .expiryNote {
            font-size: 11px;
            color: #666;
            margin-top: 8px;
          }
        }

        .cardActions {
          display: flex;
          gap: 8px;

          .ant-btn {
            flex: 1;
            height: 34px;
            font-size: 12px;
            border-radius: 6px;
          }

          .ant-btn-primary {
            background: #007afe;
            border-color: #007afe;

            &:hover {
              background: #0056cc;
              border-color: #0056cc;
            }
          }

          .ant-btn-dangerous {
            background: rgba(234, 67, 53, 0.15);
            border: 1px solid rgba(234, 67, 53, 0.4);
            color: #ea4335;

            &:hover {
              background: rgba(234, 67, 53, 0.25);
            }
          }
        }
      }
    }
  }

  /* Active Shares Section */
  .activeSharesSection {
    background: #111823;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 24px;

    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 32px;
      color: ${props => props.theme.colors.primary};
    }

    .ant-table {
      background: transparent;

      .ant-table-thead > tr > th {
        background: #181e27;
        color: ${props => props.theme.colors.primary};
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        font-size: 12px;
        font-weight: 600;
      }

      .ant-table-tbody > tr {
        &:hover > td {
          background: #1c232e !important;
        }

        > td {
          background: #181e27;
          color: ${props => props.theme.colors.primary};
          border-bottom: 1px solid rgba(255, 255, 255, 0.06);
          font-size: 12px;
        }
      }

      .ant-table-placeholder {
        background: #181e27;

        .ant-empty-description {
          color: #666;
        }
      }

      .ant-btn {
        font-size: 11px;
        height: 30px;
        border-radius: 6px;
      }
    }

    .ant-pagination {
      .ant-pagination-item,
      .ant-pagination-prev,
      .ant-pagination-next {
        background: #181e27;
        border-color: rgba(255, 255, 255, 0.1);

        a {
          color: ${props => props.theme.colors.primary};
        }
      }

      .ant-pagination-item-active {
        background: #007aff;
        border-color: #007aff;

        a {
          color: white;
        }
      }
    }
  }

  /* Sent invitations Section */
  .sentInvitationsSection {
    background: #111823;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 20px;

    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 32px;
      color: ${props => props.theme.colors.primary};
    }

    .ant-table {
      background: transparent;

      .ant-table-thead > tr > th {
        background: #181e27;
        color: ${props => props.theme.colors.primary};
        border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        font-size: 12px;
        font-weight: 600;
      }

      .ant-table-tbody > tr {
        &:hover > td {
          background: #1c232e !important;
        }

        > td {
          background: #181e27;
          color: ${props => props.theme.colors.primary};
          border-bottom: 1px solid rgba(255, 255, 255, 0.06);
          font-size: 12px;
        }
      }

      .ant-table-placeholder {
        background: #181e27;

        .ant-empty-description {
          color: #666;
        }
      }

      .ant-tag {
        font-size: 10px;
        text-transform: capitalize;
        border-radius: 4px;
      }

      .ant-btn {
        font-size: 11px;
        height: 30px;
        border-radius: 6px;
      }
    }

    .ant-pagination {
      .ant-pagination-item,
      .ant-pagination-prev,
      .ant-pagination-next {
        background: #181e27;
        border-color: rgba(255, 255, 255, 0.1);

        a {
          color: ${props => props.theme.colors.primary};
        }
      }

      .ant-pagination-item-active {
        background: #007aff;
        border-color: #007aff;

        a {
          color: white;
        }
      }
    }
  }

  /* Shared With Me Section */
  .sharedWithMeSection {
    background: #111823;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 24px;

    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 32px;
      color: ${props => props.theme.colors.primary};
    }

    .profileCards {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
      gap: 12px;
      margin-top: 16px;

      .profileCard {
        background: #181e27;
        border: 1px solid rgba(255, 255, 255, 0.08);
        border-radius: 10px;
        padding: 18px;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        transition: all 0.2s ease;

        &:hover {
          border-color: rgba(0, 122, 254, 0.3);
        }

        .ant-avatar {
          margin-bottom: 10px;
        }

        .profileName {
          font-size: 15px;
          color: ${props => props.theme.colors.primary};
          font-weight: 600;
          margin-bottom: 4px;
        }

        .ownerName {
          font-size: 12px;
          color: #888;
          margin-bottom: 14px;
        }

        .ant-btn {
          width: 100%;
          height: 34px;
          font-size: 12px;
          background: rgba(234, 67, 53, 0.15);
          border: 1px solid rgba(234, 67, 53, 0.4);
          color: #ea4335;
          border-radius: 6px;

          &:hover {
            background: rgba(234, 67, 53, 0.25);
            border-color: rgba(234, 67, 53, 0.5);
            color: #ea4335;
          }
        }
      }
    }

    .emptyState {
      text-align: center;
      padding: 32px;
      color: #666;
      font-size: 13px;
    }
  }

  /* Responsive */
  @media screen and (max-width: 800px) {
    .invitationCards {
      grid-template-columns: 1fr !important;
    }

    .profileCards {
      grid-template-columns: 1fr !important;
    }

    .inviteSection,
    .pendingInvitationsSection,
    .activeSharesSection,
    .sharedWithMeSection,
    .sentInvitationsSection {
      padding: 16px;
    }

    .upgradePrompt {
      padding: 20px;

      h2 {
        font-size: 16px;
      }
    }

    h3 {
      font-size: 15px;
    }
  }
`;
